import { PermissionModal } from './PermissionModal';
import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import React from 'react';
import { Row, Col, Button, Modal, Input, message, Tooltip, Popconfirm, Space, Checkbox, Table, Tag } from 'antd';
import {
    DeleteOutlined, EditOutlined, SettingOutlined, DashboardTwoTone,
    PieChartTwoTone, FundTwoTone, CompassTwoTone
} from '@ant-design/icons';
import { ifEmpty, isNotEmpty, isEmpty } from '../Service/Utils';

const tipsKey = 'queryGuide.visualization.boards.tips';

class VisualizationSummariesView extends React.Component {

    static boardsViewDelta = 285

    constructor() {
        super();
        this.state = {
            visualizationConfirmModal: {
                visible: false,
            },
            permissionModal: {
                visible: false,
                incomingVid: 0,
            },
            total: 0,
            pageSize: 20,
            pageNo: 1,
            ownsOnly: false,
            searchKey: '',
            boards: [],
            boardsViewHeight: document.body.clientHeight - VisualizationSummariesView.boardsViewDelta,
            viewType: 'list'
        };
    }

    render() {
        return <>
            <Row style={{ margin: '12px 0 0 0' }}>
                <Col flex='300px' style={{ alignSelf: 'center' }}>
                    <Input.Search
                        value={this.state.searchKey}
                        onChange={({ target: { value } }) => this.refreshBoards({ searchKey: value, pageNo: 1 })}
                        placeholder="按名字、创建者搜索"
                        style={{ width: '100%' }}
                    />
                </Col>
                <Col style={{ alignSelf: 'center', margin: '0 0 0 10px' }}>
                    <Checkbox
                        checked={this.state.ownsOnly}
                        onChange={({ target: { checked } }) => this.refreshBoards({ ownsOnly: checked, pageNo: 1 })}
                    >只看自己</Checkbox>
                </Col>
                <Col flex="auto"></Col>
                <Col>
                    <Button
                        type='primary'
                        onClick={() => this.setState(({ visualizationConfirmModal }) => {
                            visualizationConfirmModal.visible = true;
                            return { visualizationConfirmModal };
                        })}
                    >新建看板</Button>
                </Col>
            </Row>
            <Row style={{ margin: '12px 0 0 0' }}>
                <Col flex='100%'>
                    <Table
                        dataSource={this.state.boards}
                        rowKey='id'
                        size='small'
                        bordered
                        scroll={{ x: 1000, y: this.state.boardsViewHeight }}
                        pagination={{
                            total: this.state.total,
                            current: this.state.pageNo,
                            pageSize: this.state.pageSize,
                            onChange: (pageNo, pageSize) => this.refreshBoards({ pageNo, pageSize })
                        }}
                        style={{ width: '100%' }}
                    >
                        <Table.Column
                            title='名称'
                            dataIndex='name'
                            width={250}
                            render={(name, board) => <Space>
                                <Button
                                    type='link'
                                    //href={`/standalone/visualizations/${board.id}`}
                                    onClick={() => window.open(`/standalone/visualizations/${board.id}`)}
                                    style={{ width: '100%' }}
                                >{(isNotEmpty(name) && name.length > 20) 
                                    ? <Tooltip title={name}>{name.substring(0, 20)+"..."}</Tooltip>
                                    : <span>{name}</span>}</Button>
                            </Space>}
                        />
                        <Table.Column
                            title='创建人'
                            width={100}
                            dataIndex='creatorName'
                        />
                        <Table.Column
                            title='更新时间'
                            width={200}
                            dataIndex='updatedAt'
                        />
                        <Table.Column
                            title='刷新时间'
                            width={80}
                            dataIndex='dailyRefreshAt'
                            render={dailyRefreshAt => isEmpty(dailyRefreshAt) ? undefined : <Tag color='#1890ff'>{dailyRefreshAt}</Tag>}
                        />
                        {/* <Table.Column
                            title='使用成本'
                            width={100}
                            align='right'
                            dataIndex='cost'
                        /> */}
                        <Table.Column
                            title='说明'
                            width={300}
                            dataIndex='desc'
                        />
                        <Table.Column
                            title='操作'
                            dataIndex='id'
                            width={80}
                            render={(_, board) => board.perm === 'EDIT' && <>

                                <Tooltip title='编辑看板'>
                                    <Button
                                        icon={<EditOutlined />}
                                        size='small'
                                        type='link'
                                        href={`/querying_guide/visualization/${board.id}/edit`}
                                    >
                                    </Button>
                                </Tooltip>
                                <Tooltip title='分配权限'>
                                    <Button
                                        icon={<SettingOutlined />}
                                        size='small'
                                        type='link'
                                        onClick={() => this.setState(({ permissionModal }) => {
                                            permissionModal.visible = true;
                                            permissionModal.vid = board.id;
                                            return { permissionModal };
                                        })}
                                    >
                                    </Button>
                                </Tooltip>
                                <Popconfirm
                                    title='是否删除指定的看板'
                                    onConfirm={async () => {
                                        await UIFetchService.delete(`/api/v1/querying_guide/visualization/${board.id}`);
                                        this.refreshBoards();
                                    }}
                                >
                                    <Button
                                        icon={<DeleteOutlined />}
                                        size='small'
                                        danger
                                        type='link'
                                    ></Button>
                                </Popconfirm>
                            </>
                            }
                        />
                    </Table>
                </Col>
            </Row>
            {this.state.visualizationConfirmModal.visible && <VisualizationConfirmModal
                visible={this.state.visualizationConfirmModal.visible}
                title="新建可视化看板"
                onCancel={() => this.setState(({ visualizationConfirmModal }) => {
                    visualizationConfirmModal.visible = false;
                    return { visualizationConfirmModal };
                })}
            />}
            {this.state.permissionModal.visible && <PermissionModal
                visible={this.state.permissionModal.visible}
                title="看板权限管理"
                onCancel={() => this.setState(({ permissionModal }) => {
                    permissionModal.visible = false;
                    return { permissionModal };
                })}
                getUsers={async () => await this.getBoardPermUsers(this.state.permissionModal.vid)}
                setUsers={async (viewers, editors) => await this.setBoardPermUsers(this.state.permissionModal.vid, viewers, editors)}
            />}
            <Modal
                visible={this.state.tipsModalVisible}
                title='Tips'
                onOk={() => {
                    this.setState({ tipsModalVisible: false });
                    localStorage.setItem(tipsKey, 'false');
                }}
                okText='我知道了'
                onCancel={() => this.setState({ tipsModalVisible: false })}
            >
                <Row>
                    <Col>
                        <span>点击</span>
                        <Space>
                            <DashboardTwoTone
                                twoToneColor='rgb(99,116,199)'
                            />
                            <PieChartTwoTone
                                twoToneColor='rgb(57,184,255)'
                            />
                            <FundTwoTone
                                twoToneColor='rgb(101,202,146)'
                            />
                            <CompassTwoTone
                                twoToneColor='rgb(88,133,226)'
                            />
                        </Space>
                        <span>直接查看看板内容。</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span>以下按钮必须拥有看板的编辑权限，才会存在：</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span><Button
                            icon={<SettingOutlined />}
                            size='small'
                            type='link'
                        /> → 分配查看和编辑权限。</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span><Button
                            icon={<EditOutlined />}
                            size='small'
                            type='link'
                        /> → 编辑看板内容。</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span><Button
                            icon={<DeleteOutlined />}
                            size='small'
                            danger
                            type='link'
                        /> → 删除看板。</span>
                    </Col>
                </Row>
            </Modal>
        </>;
    }

    async componentDidMount() {
        await this.refreshBoards();
        const showTips = localStorage.getItem(tipsKey);
        if (isEmpty(showTips) || showTips === 'true') {
            this.setState({ tipsModalVisible: true });
        }
        window.onresize = () => {
            // boardsViewHeight: document.body.clientHeight - VisualizationSummariesView.boardsViewDelta
            this.setState({ boardsViewHeight: document.body.clientHeight - VisualizationSummariesView.boardsViewDelta });
        };
    }

    componentWillUnmount() {
        delete window.onresize;
    }

    async refreshBoards(params) {
        if (params === undefined || params === null) {
            params = {};
        }
        const keys = [
            'pageNo',
            'pageSize',
            'ownsOnly',
            'searchKey'
        ];
        for (const key of keys) {
            if (params[key] === undefined) {
                params[key] = this.state[key];
            }
        }
        this.setState(params);
        const query = Object.keys(params).map(key => `${key}=${encodeURI(ifEmpty(params[key], ''))}`).join('&');
        const rs = await UIFetchService.get(`/api/v1/querying_guide/visualization/summaries?${query}`);
        if (!rs) {
            return;
        }
        this.setState({ total: rs.total, boards: rs.items });
    }

    async getBoardPermUsers(vid) {
        const viewers = await UIFetchService.get(`/api/v1/querying_guide/visualization/${vid}/perm_staffs?action=VIEW`);
        const editors = await UIFetchService.get(`/api/v1/querying_guide/visualization/${vid}/perm_staffs?action=EDIT`);
        return { viewers, editors };
    }

    async setBoardPermUsers(vid, viewers, editors) {
        await UIFetchService.put(`/api/v1/querying_guide/visualization/${vid}/perm_staffs?action=VIEW`, viewers);
        await UIFetchService.put(`/api/v1/querying_guide/visualization/${vid}/perm_staffs?action=EDIT`, editors);
    }
}

class VisualizationConfirmModal extends React.Component {
    constructor() {
        super();
        this.state = {

        };
    }


    render() {
        return <Modal
            {...this.props}
            maskClosable={true}
            onOk={async () => await this.onCommit()}
        >
            <Row style={{ margin: '0 0 10px 0' }}>
                <Col flex='80px' style={{ alignSelf: 'center', textAlign: 'right' }}>
                    <span>名称：</span>
                </Col>
                <Col flex='auto'>
                    <Input
                        value={this.state.name}
                        onChange={({ target: { value } }) => {
                            this.setState({ name: value });
                        }}
                        placeholder="请输入可视化看板名称"
                    ></Input>
                </Col>
            </Row>
            <Row>
                <Col flex='80px' style={{ textAlign: 'right' }}>
                    <span>说明：</span>
                </Col>
                <Col flex='auto'>
                    <Input.TextArea
                        value={this.state.desc}
                        onChange={({ target: { value } }) => {
                            this.setState({ desc: value });
                        }}
                        rows={2}
                    >
                    </Input.TextArea>
                </Col>
            </Row>
        </Modal>;
    }

    async onCommit() {
        if (isEmpty(this.state.name)) {
            message.error('名称不能为空');
            return;
        }

        const rs = await UIFetchService.post('/api/v1/querying_guide/visualization', this.state);
        if (!rs) {
            return rs;
        }
        auth.appendLog('天机可视化-新建看板');
        window.location = `/querying_guide/visualization/${rs.vid}/edit`;
    }
}

export default VisualizationSummariesView;